import { PropertyExpenseDTO } from "../DTO/propertyExpenseDTO";

export class StorePropertyExpenseRequest{
    public userId!:string;
    public businessId!:string;
    public propertyExpense!:PropertyExpenseDTO;
}